/* @flow */
import * as React from 'react';

import Text from 'components/Text.jsx';
import TextWithGlyph from 'components/TextWithGlyph.jsx';

import type { Props as TextProps } from 'components/Text.jsx';

type Props = {
  number: number,
  isPercentage?: boolean,
  label?: string,
  labelProps: $Shape<TextProps>,
};

function ErrorCell({ number, isPercentage, label, labelProps }: Props) {
  if (isNaN(number)) {
    return <span />;
  }
  const hasErrors = number > 0;

  if (label && hasErrors) {
    return (
      <TextWithGlyph
        glyphColor="lava"
        weight="semibold"
        color="lava"
        glyph="explanation-circle"
        {...labelProps}>
        {label}
      </TextWithGlyph>
    );
  }

  const content = isPercentage ? `${number * 100}%` : number;
  return (
    <Text
      weight={hasErrors ? 'semibold' : 'normal'}
      color={hasErrors ? 'lava' : 'inherit'}
      {...labelProps}>
      {label || content}
    </Text>
  );
}

export function getErrorCellGenerator(fieldName: string, labelProps?: $Shape<TextProps>) {
  return (data: Object) => {
    return <ErrorCell number={data[fieldName]} labelProps={labelProps || {}} />;
  };
}

export function getErrorPercentageCellGenerator(fieldName: string, labelProps?: $Shape<TextProps>) {
  return (data: Object) => {
    return <ErrorCell number={data[fieldName]} isPercentage labelProps={labelProps || {}} />;
  };
}

export function getErrorTextCellGenerator(
  fieldName: string,
  numberOfErrorsField: string,
  labelProps?: $Shape<TextProps>
) {
  return (data: Object) => {
    return (
      <ErrorCell
        label={data[fieldName]}
        number={data[numberOfErrorsField]}
        labelProps={labelProps || {}}
      />
    );
  };
}
